<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="page_1">Praise for <span class="txit">An Unsuitable Job for a Woman</span></a></p><a id="page_1">
<p class="blockquote">“The reigning mistress of murder… [her] vivid, compelling whodunits over almost a quarter of a century have made James one of the world’s leading crime writers and a worthy successor to Sir Arthur Conan Doyle and Agatha Christie.”</p>
<p class="att">—<span class="txit">Time</span></p>
<p class="blockquote">“She writes like an angel. Every character is clearly drawn. Her atmosphere is unerringly, chillingly convincing. And she manages all this without for a moment slowing down the drive and tension of an exciting mystery.”</p>
<p class="att">—<span class="txit">London Times</span></p>
<p class="blockquote">“If we’re lucky, there will always be an England, and there will always be a P. D. James.”</p>
<p class="att">—<span class="txit">Cosmopolitan</span></p>
<p class="blockquote">“Ms. James is simply a wonderful writer.”</p>
<p class="att"><span class="txit">—The New York Times Book Review</span></p>
<p class="blockquote">“The nonpareil of the literary mystery… she transcends simple literary classification.”</p>
<p class="att">—<span class="txit">Chicago Sun-Times</span></p>
<p class="blockquote">“Written in the 1970s, this thriller has lost none of its punch.”</p>
<p class="att">—<span class="txit">Vogue</span></p>
<p class="center1">Praise for P. D. James</p>
<p class="blockquote">“One reads a P. D. James novel in something like the spirit that one reads a novel by Zola, Balzac, Thackeray, or Dickens.”</p>
<p class="att">—<span class="txit">The Christian Science Monitor</span></p>
</a><p class="blockquote"><a id="page_1"></a><a id="page_2">“The ability to haunt has earned P. D. James the title ‘queen of crime.’ Long may she reign.”</a></p><a id="page_2">
<p class="att">—<span class="txit">Chicago Sun-Times</span></p>
<p class="blockquote">“P. D. James… writes the most lethal, erudite, people-complex novels of murder and detection since Michael Innes first began and Dorothy Sayers left us.”</p>
<p class="att">—<span class="txit">Vogue</span></p>
<p class="blockquote">“James delivers the pace and tensions of a mystery yarn better than any other living writer.”</p>
<p class="att">—<span class="txit">People</span></p>
<p class="blockquote">“The best practitioner of the mystery novel writing today.”</p>
<p class="att">—<span class="txit">The Boston Globe</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a_fm01.vue?96fd0916